import {useMemo} from 'react';
import type {DeletePrizeFunc, SavePrizeFunc} from 'services/data/prize';
import { usePrize} from 'services/data/prize';
import type {PrizeState} from 'services/data/prize/reducer/prizeReducer';
import type {NewPrizeParam, PrizeIdParam} from '../types';

export const useNewOrExistingPrize = ({
  prizeId,
  suggestion,
}: NewPrizeParam | PrizeIdParam):
  | {
      /** Loaded prize, with limit works data */
      prize: PrizeState;
      suggestion?: undefined;
      savePrize: SavePrizeFunc;
      deletePrize: DeletePrizeFunc;
    }
  | {
      prize?: undefined;
      suggestion: string;
      savePrize: SavePrizeFunc;
      deletePrize: DeletePrizeFunc;
    } => {
  const {prize: existingPrize, savePrize, deletePrize} = usePrize(prizeId);

  return useMemo(() => {
    if (prizeId) {
      return {prize: existingPrize, savePrize, deletePrize};
    }

    return {
      suggestion: suggestion ?? '',
      savePrize,
      deletePrize,
    };
  }, [prizeId, deletePrize, existingPrize, savePrize, suggestion]);
};
